const contactFormWrapper = document.querySelector('.custom-contact-wrapper');
const openCustomModal = document.getElementById('openCustomModal');
if (contactFormWrapper && openCustomModal) {
	let modalError = false;

	const modalTime = document.getElementById('modalTime');
	const modalTimezone = document.getElementById('modalTimezone');
	const timezoneModal = document.getElementById('timezoneModal');
	const openTimeModal = document.getElementById('openTimeModal');
	const timezoneCloseBtn = document.getElementById('timezoneCloseBtn');
	const timezoneSetTime = document.getElementById('timezoneSetTime');
	const timeInput = document.getElementById('timeInput');
	const timezoneInput = document.getElementById('timezoneInput');
	const contactSpecificTime = document.getElementById('contactSpecificTime');
	const contactSpecificTimeLabel = document.getElementById('contactSpecificTimeLabel');
	const customContactFormWrapper = document.getElementById('customContactFormWrapper');
	const closeCustomModal = document.getElementById('closeCustomModal');
	const timezoneError = document.getElementById('timezoneError');
	const timezoneResetTime = document.getElementById('timezoneResetTime');

	const toggleMainModal = () => {
		customContactFormWrapper.classList.toggle('hidden');
		document.body.style.overflow === 'hidden'
			? (document.body.style.overflow = '')
			: (document.body.style.overflow = 'hidden');

		// click by backdrop
		const closeByBackdrop = (e) => {
			if (e.target === e.currentTarget) {
				customContactFormWrapper.classList.add('hidden');
				document.body.style.overflow = '';
			}
		};
		if (!customContactFormWrapper.classList.contains('hidden')) {
			customContactFormWrapper.addEventListener('click', closeByBackdrop);
		} else {
			customContactFormWrapper.removeEventListener('click', closeByBackdrop);
		}
	};
	const toggleTimezoneModal = () => {
		timezoneModal.classList.toggle('hidden');
		// click by backdrop
		if (!timezoneModal.classList.contains('hidden')) {
			timezoneModal.addEventListener('click', (e) => {
				if (e.target === e.currentTarget) {
					timezoneModal.classList.add('hidden');
				}
			});
		} else {
			timezoneModal.removeEventListener('click');
		}
	};
	// if page load after submting form
	if (window.location.hash === '#CustomCallForm') {
		toggleMainModal();
	}

	openCustomModal.addEventListener('click', toggleMainModal);
	closeCustomModal.addEventListener('click', toggleMainModal);

	// timezone modal

	const checkIfBothFieldsFilled = () => {
		if (modalTime.value === '' || modalTimezone.value === '') {
			return (modalError = true);
		} else {
			return (modalError = false);
		}
	};

	const togglePlaceholder = (e) => {
		if (e.target.value !== '') {
			e.target.classList.remove('c-placeholder');
			timezoneResetTime.removeAttribute('disabled');
		} else {
			e.target.classList.add('c-placeholder');
		}
	};
	openTimeModal.addEventListener('click', toggleTimezoneModal);
	timezoneCloseBtn.addEventListener('click', toggleTimezoneModal);
	modalTime.addEventListener('input', togglePlaceholder);
	modalTimezone.addEventListener('input', togglePlaceholder);

	timezoneResetTime.addEventListener('click', () => {
		modalTime.value = '';
		modalTimezone.value = '';
		timeInput.value = '';
		timezoneInput.value = '';
		timezoneModal.classList.toggle('hidden');
		contactSpecificTimeLabel.classList.remove('c-focused');
		contactSpecificTime.classList.remove('c-focused');
		timezoneResetTime.setAttribute('disabled', '');
	});

	timezoneSetTime.addEventListener('click', () => {
		checkIfBothFieldsFilled();
		if (modalError) {
			timezoneError.classList.remove('hidden');
		} else {
			timezoneError.classList.add('hidden');
			timeInput.value = modalTime.value;
			timezoneInput.value = modalTimezone.value;
			timezoneModal.classList.toggle('hidden');
			contactSpecificTimeLabel.classList.add('c-focused');
			contactSpecificTime.classList.add('c-focused');
		}
	});

	//  todo - clear eventlistener if modal closed
}
